import { render, staticRenderFns } from "./editIdNumber.vue?vue&type=template&id=41226ed1&scoped=true"
import script from "./editIdNumber.vue?vue&type=script&lang=js"
export * from "./editIdNumber.vue?vue&type=script&lang=js"
import style0 from "./editIdNumber.vue?vue&type=style&index=0&id=41226ed1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41226ed1",
  null
  
)

export default component.exports